$(document).ready(function(){
  

    $('.custom-search-icon').click(function(){
      $('.lantev_search_icon').toggleClass('full-search');
      $(this).addClass('click-button');

    });
  
  
  
//   $(document).click(function(event) {
//     //if you click on anything except the modal itself or the "open modal" link, close the modal
//     if (!$(event.target).closest(".site-header__search-toggle, .search-bar__input").length) {
//       $("body").removeClass("js-drawer-open js-drawer-open-top prevent-scrolling");
//     }
//   });
  
    
    // logo slider
    $('.logos-slider').slick({
        dots: false,
        infinite: true,
        speed: 2000,
        arrows:false,
        slidesToShow: 10,
        centerMode: true,
      	autoplaySpeed: 0,
		cssEase: 'linear',
        autoplay:true,
     
      
       	centerPadding:"100px",
      
       responsive: [
        {
          breakpoint: 1441,
          settings: {
          
            slidesToShow: 7
          }
        },
        {
          breakpoint: 1200,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 6
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 4
          }
        },
        {
          breakpoint: 577,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 481,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '130px',
            slidesToShow: 1
          }
        }
      ]
    
      });


      // product slider
     
  

      $('.product-slider').slick({
        infinite: true,
        speed: 300,
        arrows: true,
        slidesToShow: 5,
        autoplay:false,
        prevArrow:'.prev-tab-arrow',
  		nextArrow:'.next-tab-arrow',
        slidesToScroll: 1,
        responsive:[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow:3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow:2
            }
          },
          
          {
            breakpoint: 576,
            settings: {
              slidesToShow:2
            }
          }
          
        ]
      });


      
  $('#toggle_btn').click(function(){

    $('#toggle_btn').toggleClass('toggle_active');
    $('.mobile-menu-wrapper').toggleClass('menu-active')
  });


  $('.mobile-menu-wrapper ul li').click(function(){
    $('.submenu-list').slideToggle('block-submenu');
  })
  
  
//   sticky header
  
  
  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('header').addClass('fixed-header');
    } else {
       $('header').removeClass('fixed-header');
    }
});
  
  
// var previousScroll = 0;
// $(window).scroll(function(event){
//    var scroll = $(this).scrollTop();
//    if (scroll > previousScroll){
//     $('header').addClass('scrolldown');
//     $('header').removeClass('fixed-header');
//    } else {
//     $('header').addClass('fixed-header');
//     $('header').removeClass('scrolldown');
//    }
//    previousScroll = scroll;
// });

// $(window).scroll(function () {
//   if ($(window).scrollTop() < 50) {
//     $('header').removeClass('fixed-header');
//     $('header').removeClass('scrolldown');
//   }
 
// });
  
  
  
  $('a[href^="#"]').on('click',function (e) {
	    e.preventDefault();
	    var target = this.hash;
	    var $target = $(target);
	    $('html, body').stop().animate({
	        'scrollTop': $target.offset().top - 180
	    }, 900, 'swing', function () {
	        // window.location.hash = target;
	    });
	});
  
  
  $('.subnav li a').click(function(){
    
  
    var target2 = $($(this).attr('href'));
    if(target2.length){
      var scrollTo = target2.offset().top - 100;
      $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
    }
  });
  
 
  
  if ($(window).width() > 767) {
   var rellax = new Rellax('.rellax');
  }
  else {
   var rellax = new Rellax('.abc');
  }
  
  if ($(window).width() < 480) {
    $('.custom-site-header button.hide-on-desktop').click(function(){
    	$('.lantev_search_icon').toggleClass('search-mobile');
    });
  }
  else {
   $('.custom-site-header button.hide-on-desktop').click(function(){
    	$('.lantev_search_icon').removeClass('search-mobile');
    });
  }
  
  if ($(window).width() > 480) {
    $('.search-bar__input').click(function(){
      $(this).parents('.lantev_search_icon').addClass('full-search')
    });
  }
  else {
   $('.search-bar__input').click(function(){
      $(this).parents('.lantev_search_icon').removeClass('full-search')
    });
  }
  

  
  AOS.init({
    duration: 1000,
    offset: 0,
  });
  
  
//   jQuery('.jarallax').jarallax({
//     speed: .2
//   });

  
  
    if($(window).width() < 3000){
          
//           var footeranim = $('footer').offset().top - $(window).height() + $('footer').height() / 2;
          
				
//           $(window).scroll(function(){
//             // third section dot animation
//             var footeranimvar = $(this).scrollTop() - footeranim ;
//             if($(this).scrollTop() > footeranim)
//             {
//               $('.footer-wrapper').css({
//                 transform: "translate(0px,"+ -footeranimvar/2.1+"px)"
//               });
              
//             }


//           });
      
//        var getheight = $('#PageContainer').height() - $('footer').height() - 100;
//       alert(getheight)
      
//       $(window).scroll(function(){
//         if($(this).scrollTop() > getheight){
//         	$('footer').addClass('anim-footer');
//         }
//         else{
//         	$('footer').removeClass('anim-footer');
//         }
//       })
      
    }
  
  


//   gsap.to(".footer-wrapper", {
//     yPercent: -40,
//     ease: "none",
//     scrub: 0.3,
//     scrollTrigger: {
//       trigger: ".footer-wrapper",
//       // start: "top bottom", // the default values
//       // end: "bottom top",
//       scrub: true
//     }, 
//   });



 
//   jQuery(window).scroll(function(){
//     var getheight = $('#PageContainer').height() - $('.footer-wrapper').height() + 200;
//        if($(this).scrollTop() > getheight){
//          	$('.footer-wrapper').addClass('anim-footer');
//          }
//          else{
//          	$('.footer-wrapper').removeClass('anim-footer');
//          }

// })
  
  
 
});



  







  
